import { IconType } from '../icons';

export const gameTypeDetails = Object.freeze<
  Record<string, { displayName: string; icon: IconType }>
>({
  notFound: { displayName: 'Dictation', icon: IconType.PictureProblemWhite },
  show: { displayName: 'Show', icon: IconType.SlideShow },
  dictation: { displayName: 'Dictation', icon: IconType.GameTypeDictation },
  recitation: { displayName: 'Recitation', icon: IconType.GameTypeRecitation },
  lyricsDictation: {
    displayName: 'Lyrics JOY · Dictation',
    icon: IconType.GameTypeLyricsDictation,
  },
  lyricsRecitation: {
    displayName: 'Lyrics JOY · Recitation',
    icon: IconType.GameTypeLyrics,
  },
  lyricsSpeaking: {
    displayName: 'Lyrics JOY · Speaking',
    icon: IconType.GameTypeLyricsSpeak,
  },
  jumbledSentence: {
    displayName: 'Jumbled JOY',
    icon: IconType.GameTypeSentenceRestructure,
  },
  jumbledSentenceListening: {
    displayName: 'Jumbled JOY · By Listening',
    icon: IconType.GameTypeSentenceRestructureListening,
  },
  fingerWritingAdvance: {
    displayName: 'Writing JOY · Advanced (no shadow)',
    icon: IconType.GameTypeFingerWritingAdv,
  },
  fingerWritingComponent: {
    displayName: 'Writing JOY · Basic (components with shadow)',
    icon: IconType.GameTypeFingerWritingComponent,
  },
  fingerWriting: {
    displayName: 'Writing JOY · Intermediate (whole word with shadow)',
    icon: IconType.GameTypeFingerWriting,
  },
  fingerWritingDictation: {
    displayName: 'Writing JOY · Dictation',
    icon: IconType.GameTypeFingerWritingDictation,
  },
  listening: {
    displayName: 'Fast Listening JOY',
    icon: IconType.GameTypeListening,
  },
  ordering: { displayName: 'Ordering JOY', icon: IconType.GameTypeSequence },
  matching: {
    displayName: 'Matching JOY',
    icon: IconType.GameTypeWordMatching,
  },
  multipleChoice: {
    displayName: 'Multiple JOY',
    icon: IconType.GameTypeMultipleChoice,
  },
  fillInTheBlanksBySpelling: {
    displayName: 'Fill-in-the-JOY · By Spelling',
    icon: IconType.GameTypeFillBlankSpelling,
  },
  fillInTheBlanksByWord: {
    displayName: 'Fill-in-the-JOY · By Word',
    icon: IconType.GameTypeFillBlankWords,
  },
  conversation: {
    displayName: 'Speaking JOY · Conversation',
    icon: IconType.GameTypeDialogsConversation,
  },
  followMeToSpeak: {
    displayName: 'Speaking JOY · Follow to Speak',
    icon: IconType.GameTypeSpeakingListen,
  },
  readAloud: {
    displayName: 'Speaking JOY · Read to Speak',
    icon: IconType.GameTypeSpeakingRead,
  },
  readAloudRecite: {
    displayName:
      'Speaking JOY · Conversation with AI Rating (memorized answer)',
    icon: IconType.GameTypeSpeakingRecite,
  },
  fingerWritingInkless: {
    displayName: 'AI Fun Handwriting · Ink-less Stroke',
    icon: IconType.GameTypeFingWritingInkless,
  },
  fingerWritingStroke: {
    displayName: 'AI Fun Handwriting · Jumbled Stroke',
    icon: IconType.GameTypeFingerWritingStroke,
  },
  joyachess: {
    displayName: 'JOYAChess',
    icon: IconType.MultiplayerGameTypeJoyachess,
  },
  fiveLoavesTwoFish: {
    displayName: 'Five Loaves Two Fish',
    icon: IconType.MultiplayerGameTypeFiveLoavesTwoFish,
  },
  ticTacToe: {
    displayName: 'Tic-Tac-JOY',
    icon: IconType.MultiplayerGameTypeTicTacToe,
  },
  gomoku: {
    displayName: 'Gomoku JOY',
    icon: IconType.MultiplayerGameTypeGomoku,
  },
  joyachessSingle: {
    displayName: 'JOYAChess · Single Player',
    icon: IconType.MultiplayerGameTypeJoyachess,
  },
  joyachessTeam: {
    displayName: 'JOYAChess · Team',
    icon: IconType.MultiplayerGameTypeJoyachess,
  },
  joyachessPersonalName: {
    displayName: 'JOYAChess · Personal Name',
    icon: IconType.GameModeNameChess,
  },
  joyachessTeamName: {
    displayName: 'JOYAChess · Organization Name',
    icon: IconType.GameModeNameChess,
  },
  joyaPassage: {
    displayName: 'Quick Memory JOY',
    icon: IconType.GameTypeJoyAPassage,
  },
  speaking: {
    displayName: 'AI Active Speaking · Fast Speaking',
    icon: IconType.GameTypeFastSpeaking,
  },
  syllable: {
    displayName: 'Spelling JOY · By Syllables',
    icon: IconType.GameTypeSpellSyllable,
  },
  spelling: {
    displayName: 'Spelling JOY · By Characters',
    icon: IconType.GameTypeSpellingBig,
  },
});
export const getGameTypeDetails = (
  gameTypeKey: string,
): { displayName: string; icon: IconType } =>
  gameTypeDetails[gameTypeKey] || {
    displayName: 'not found',
    icon: IconType.PictureProblemWhite,
  };

// export const GameTypeName = Object.freeze<Record<string, string>>({
//   notFound: 'Dictation',
//   show: 'Show',
//   dictation: 'Dictation',
//   recitation: 'Recitation',
//   lyricsDictation: 'Lyrics JOY · Dictation',
//   lyricsRecitation: 'Lyrics JOY · Recitation',
//   lyricsSpeaking: 'Lyrics JOY · Speaking',
//   jumbledSentence: 'Jumbled JOY',
//   jumbledSentenceListening: 'Jumbled JOY · By Listening',
//   fingerWritingAdvance: 'Writing JOY · Advanced (no shadow)',
//   fingerWritingComponent: 'Writing JOY · Basic (components with shadow)',
//   fingerWriting: 'Writing JOY · Intermediate (whole word with shadow)',
//   fingerWritingDictation: 'Writing JOY · Dictation',
//   spelling: 'Spelling JOY · By Characters',
//   listening: 'Fast Listening JOY',
//   ordering: 'Ordering JOY',
//   matching: 'Matching JOY',
//   multipleChoice: 'Multiple JOY',
//   fillInTheBlanksBySpelling: 'Fill-in-the-JOY · By Spelling',
//   fillInTheBlanksByWord: 'Fill-in-the-JOY · By Word',
//   conversation: 'Speaking JOY · Conversation',
//   followMeToSpeak: 'Speaking JOY · Follow to Speak',
//   readAloud: 'Speaking JOY · Read to Speak',
//   readAloudRecite:
//     'Speaking JOY · Conversation with AI Rating (memorized answer)',
//   fingerWritingInkless: 'AI Fun Handwriting · Ink-less Stroke',
//   fingerWritingStroke: 'AI Fun Handwriting · Jumbled Stroke',
//   joyachess: 'JOYAChess',
//   fiveLoavesTwoFish: 'Five Loaves Two Fish',
//   ticTacToe: 'Tic-Tac-JOY',
//   gomoku: 'Gomoku JOY',
//   joyachessSingle: 'JOYAChess · Single Player',
//   joyachessTeam: 'JOYAChess · Team',
//   joyachessPersonalName: 'JOYAChess · Personal Name',
//   joyachessTeamName: 'JOYAChess · Organization Name',
//   joyaPassage: 'Quick Memory JOY',
//   speaking: 'AI Active Speaking · Fast Speaking',
//   syllable: 'Spelling JOY · By Syllables',
// });
// export const getGameTypeName = (gameTypeKey: string): string =>
//   GameTypeName[gameTypeKey] || 'not found';
